(function () {
  'use strict';
  if (window.PMPabCartBridge) return;
  const VERSION = 1;
  const METRIC = 'PM PAB Cart Updated';
  const ACTIVITY = 'PM PAB Shopping Activity';
  const STORAGE = 'pm:pab:cart-bridge:v1';
  const ROOT = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  const nativeFetch = window.fetch.bind(window);
  let timer, running = false, dirty = false, latest = null, checkoutPending = false;
  let lastActivity = 0, lastSyncKey = '';
  const status = { version: VERSION, state: 'starting', events: 0 };
  function saved() { try { return JSON.parse(localStorage.getItem(STORAGE) || '{}'); } catch (_) { return {}; } }
  function remember(value) { try { localStorage.setItem(STORAGE, JSON.stringify(value)); } catch (_) {} }
  function canonical(value) {
    if (Array.isArray(value)) return '[' + value.map(canonical).join(',') + ']';
    if (value && typeof value === 'object') return '{' + Object.keys(value).sort().map(k => JSON.stringify(k) + ':' + canonical(value[k])).join(',') + '}';
    return JSON.stringify(value);
  }
  function properties(line) {
    const result = Object.create(null);
    Object.entries(line.properties || {}).forEach(([key, value]) => {
      if (!['__proto__', 'constructor', 'prototype'].includes(key) && value !== null && value !== '') result[key] = String(value);
    });
    return result;
  }
  function isPab(line) {
    return ['52502897590548', '52674499019028'].includes(String(line.variant_id || line.id));
  }
  function safeImage(value) {
    try {
      const url = new URL(value, location.origin);
      return value && url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
    } catch (_) { return ''; }
  }
  function recoveryItems(cart) {
    return cart.items.map(line => {
      const item = { id: Number(line.variant_id || line.id), quantity: Number(line.quantity), properties: properties(line) };
      const plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
      if (plan) item.selling_plan = Number(plan.id);
      return item;
    });
  }
  async function digest(value) {
    return Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)))).map(b => b.toString(16).padStart(2, '0')).join('');
  }
  async function encode(payload) {
    const text = new TextEncoder().encode(JSON.stringify(payload));
    let bytes = text, prefix = 'j';
    if (typeof CompressionStream === 'function') {
      bytes = new Uint8Array(await new Response(new Blob([text]).stream().pipeThrough(new CompressionStream('gzip'))).arrayBuffer());
      prefix = 'z';
    }
    let binary = '';
    bytes.forEach(b => { binary += String.fromCharCode(b); });
    return prefix + btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  async function decode(value) {
    if (!/^[zj][A-Za-z0-9_-]+$/.test(value) || value.length > 24000) throw new Error('Invalid saved cart link');
    const binary = atob(value.slice(1).replace(/-/g, '+').replace(/_/g, '/'));
    let bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
    if (value[0] === 'z') bytes = new Uint8Array(await new Response(new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'))).arrayBuffer());
    if (bytes.length > 150000) throw new Error('Saved cart exceeds supported size');
    const payload = JSON.parse(new TextDecoder().decode(bytes));
    if (payload.v !== VERSION || !Array.isArray(payload.items) || !payload.items.length || payload.items.length > 100) throw new Error('Invalid saved cart');
    payload.items.forEach(item => {
      if (!Number.isSafeInteger(item.id) || item.id < 1 || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || item.quantity > 9999) throw new Error('Invalid saved cart item');
      if (!item.properties || typeof item.properties !== 'object' || Array.isArray(item.properties)) throw new Error('Invalid item properties');
      item.properties = properties(item);
    });
    return payload;
  }
  async function snapshot(cart) {
    const all = recoveryItems(cart);
    const pab = cart.items.filter(isPab);
    const ready = pab.length > 0 && pab.every(line => properties(line)._custom_build === 'true' && properties(line)._build_id && safeImage(properties(line)._preview_image));
    const revision = await digest(canonical(all));
    const token = await digest(String(cart.token || '').split('?')[0]);
    const payload = { v: VERSION, items: all };
    const recoverable = all.length > 0 && all.length <= 100 && (!pab.length || ready);
    const encoded = recoverable ? await encode(payload) : '';
    const recoveryURL = encoded && encoded.length <= 16000 ? location.origin + ROOT + 'cart#pm-restore=' + encoded : '';
    const items = cart.items.filter(line => {
      const p = properties(line);
      return !['x-redo', 'priority-processing', 'order-certificate'].includes(String(line.sku || '').toLowerCase()) && p._pab_accessory_line !== 'true';
    }).map(line => {
      const p = properties(line), pabLine = isPab(line);
      return {
        'Product Name': line.product_title || line.title || '',
        'Variant Name': pabLine ? p._pab_bill_name || p['Bill Name'] || line.variant_title || '' : line.variant_title || '',
        'Variant SKU': line.sku || '', VariantID: String(line.variant_id || line.id),
        LineKey: line.key || '', Quantity: line.quantity, Price: Number(line.final_price || line.price || 0) / 100,
        URL: new URL(line.url || '/cart', location.origin).href,
        ImageURL: pabLine ? safeImage(p._preview_image) : safeImage(line.image || line.featured_image && line.featured_image.url),
        _custom_build: pabLine, _build_id: p._build_id || '', _preview_image: pabLine ? safeImage(p._preview_image) : '',
        properties: p
      };
    });
    return { Version: VERSION, Active: pab.length > 0, Ready: !!(ready && recoveryURL), Items: items, RecoveryURL: recoveryURL, Revision: revision, CartID: token, UpdatedAt: new Date().toISOString() };
  }
  function consent() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !privacy || ((!privacy.analyticsProcessingAllowed || privacy.analyticsProcessingAllowed()) && (!privacy.marketingAllowed || privacy.marketingAllowed()));
  }
  function isRecovering() {
    const recovery = window.PMPabCartRecovery;
    return !!(recovery && recovery.status && recovery.status.state === 'restoring');
  }
  function fullCartState(state, checkout) {
    return { Version: VERSION, Ready: !!(!checkout && state.Items.length && state.RecoveryURL), Items: state.Items, RecoveryURL: state.RecoveryURL, CartID: state.CartID, Revision: state.Revision, UpdatedAt: state.UpdatedAt };
  }
  async function sdk() {
    if (!consent()) return null;
    const k = window.klaviyo;
    if (k && typeof k.isIdentified === 'function' && typeof k.identify === 'function' && typeof k.track === 'function') {
      const identified = await Promise.race([Promise.resolve(k.isIdentified()), new Promise(resolve => setTimeout(() => resolve(false), 5000))]);
      if (identified) return { identify: data => k.identify(data), track: (name, data) => k.track(name, data) };
    }
    const legacy = window._learnq;
    if (!legacy || typeof legacy.isIdentified !== 'function' || !legacy.isIdentified()) return null;
    return {
      identify: data => { legacy.push(['identify', data]); return Promise.resolve(true); },
      track: (name, data) => { legacy.push(['track', name, data]); return Promise.resolve(true); }
    };
  }
  async function cart() {
    const response = await nativeFetch(ROOT + 'cart.js?pm_force_network=1&_pm_pab=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Cart read failed');
    return response.json();
  }
  async function sync() {
    if (isRecovering()) return;
    if (running) { dirty = true; return; }
    running = true;
    try {
      const state = await snapshot(await cart());
      latest = state;
      status.snapshot = state;
      const k = await sdk();
      if (!k) { status.state = 'waiting-for-identified-consented-profile'; return; }
      const previous = saved();
      checkoutPending = previous.checkout === state.Revision && previous.cart === state.CartID;
      let identityKey = '';
      try {
        const raw = (document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/) || [])[1];
        const identity = JSON.parse(atob(decodeURIComponent(raw || '')));
        identityKey = String(identity.exchange_id || identity.$exchange_id || identity.$email || identity.email || identity.$phone_number || identity.$device_id || raw);
      } catch (_) { identityKey = 'identified'; }
      identityKey = await digest(identityKey);
      const changed = previous.revision !== state.Revision || previous.cart !== state.CartID || previous.identity !== identityKey;
      if (checkoutPending) state.Ready = false;
      const syncKey = [state.CartID, state.Revision, identityKey, state.Ready].join(':');
      if (isRecovering()) return;
      if (syncKey !== lastSyncKey) {
        await k.identify({ pm_pab_cart_active: state.Active, pm_pab_cart_ready: state.Ready, pm_pab_cart_v1: state, pm_cart_v1: fullCartState(state, checkoutPending) });
        lastSyncKey = syncKey;
      }
      if (state.Ready && changed) {
        const first = state.Items.find(item => item._custom_build);
        const event = Object.assign({}, first, state, { $event_id: state.CartID + ':' + state.Revision + ':' + identityKey + ':' + Math.floor(Date.now() / 259200000), $value: state.Items.reduce((sum, item) => sum + item.Price * item.Quantity, 0) });
        const accepted = await k.track(METRIC, event);
        if (accepted === false) throw new Error('Klaviyo did not accept cart event');
        status.events++;
      }
      remember({ revision: state.Revision, cart: state.CartID, identity: identityKey, checkout: checkoutPending ? state.Revision : '' });
      status.state = state.Ready ? 'ready' : state.Active ? 'pab-incomplete-or-checkout' : 'no-pab';
    } catch (error) { status.state = 'retry-needed'; status.error = error.message; }
    finally { running = false; if (dirty) { dirty = false; schedule(); } }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 1000); }
  function mutation(url, method) {
    try { const u = new URL(url, location.origin); return u.origin === location.origin && String(method || 'GET').toUpperCase() !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?$/.test(u.pathname); } catch (_) { return false; }
  }
  window.fetch = function (input, options) {
    const url = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
    const method = options && options.method || input && input.method;
    const result = nativeFetch(input, options);
    if (mutation(url, method)) result.then(response => { if (response.ok && !isRecovering()) { checkoutPending = false; schedule(); } }).catch(() => {});
    return result;
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (mutation(url, method)) this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300 && !isRecovering()) { checkoutPending = false; schedule(); } }, { once: true });
    return xhrOpen.apply(this, arguments);
  };
  async function activity() {
    if (isRecovering() || !latest || !latest.Active || document.visibilityState === 'hidden' || Date.now() - lastActivity < 60000) return;
    lastActivity = Date.now();
    const k = await sdk();
    if (k) await k.track(ACTIVITY, { CartID: latest.CartID, $event_id: latest.CartID + ':' + Math.floor(Date.now() / 60000) });
  }
  async function checkoutIntent() {
    if (!latest || !latest.Items.length || checkoutPending) return;
    checkoutPending = true;
    latest.Ready = false;
    remember(Object.assign({}, saved(), { checkout: latest.Revision, cart: latest.CartID }));
    const k = await sdk();
    if (k) {
      await Promise.all([
        k.identify({ pm_pab_cart_active: latest.Active, pm_pab_cart_ready: false, pm_pab_cart_v1: latest, pm_cart_v1: fullCartState(latest, true) }),
        latest.Active ? k.track(METRIC, { CartID: latest.CartID, Ready: false, CheckoutIntent: true, $event_id: latest.CartID + ':checkout:' + latest.Revision }) : Promise.resolve()
      ]);
    }
  }
  document.addEventListener('click', event => {
    activity().catch(() => {});
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    const target = path.find(node => node && node.matches && node.matches('a[href],button,input')) || event.target && event.target.closest && event.target.closest('a[href],button,input');
    if (target && (target.name === 'checkout' || /^checkout(?:\+|\s+without\b.*)?$/i.test((target.textContent || target.value || '').trim()) || /\/checkout(?:[/?#]|$)/.test(target.getAttribute('href') || '') || target.closest('.shopify-payment-button'))) checkoutIntent().catch(() => {});
  }, true);
  document.addEventListener('submit', event => { if (event.submitter && event.submitter.name === 'checkout' || /\/checkout(?:[/?#]|$)/.test(event.target.action || '')) checkoutIntent().catch(() => {}); }, true);
  ['keydown', 'touchstart', 'scroll'].forEach(name => document.addEventListener(name, () => { activity().catch(() => {}); }, { passive: true }));
  ['cart:updated', 'cart:quantity-saved', 'cart:section-refreshed', 'visitorConsentCollected', 'klaviyoForms'].forEach(name => document.addEventListener(name, schedule));
  function itemIdentity(item) {
    return canonical({ id: Number(item.id || item.variant_id), properties: properties(item), selling_plan: item.selling_plan || item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id || null });
  }
  async function recover(value) {
    if (!window.PMPabCartRecovery) throw new Error('Open the saved cart recovery link to restore its items.');
    return window.PMPabCartRecovery.recover(value);
  }
  async function start() {
    if (isRecovering()) return;
    await sync();
    activity().catch(() => {});
  }
  window.PMPabCartBridge = { status, snapshot, encode, decode, recover, sync, cart, canonical, itemIdentity, checkoutIntent, activity };
  setInterval(() => { if (!isRecovering() && document.visibilityState !== 'hidden') sync(); }, 30000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();


